// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"689":"be9f13cb","984":"d704d599"}[chunkId] + ".chunk.js";
};